import CTNButton from '@ctn/ui/components/ctn-button';
import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';
import CTNSpinner from '@ctn/ui/components/ctn-spinner';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGlobalContext } from '@/context/global.context';
import { type Socio } from '@/pages/LibroSocios/interfaces/socio.interface';
import { getListadoSocios } from '@/services/socios.service';

import { ROUTES, ROUTES_LABEL } from '@/constants/routes.constants';


const ListaSociosOverview = () => {
	const navigate = useNavigate();
	const { user } = useGlobalContext();
	const className = 'c-pnp-overview';
	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [data, setData] = useState<Socio[]>();

	useEffect(() => {
		getListado();
	}, []);

	const getListado = async () => {
		setIsLoaded(false);
		try {
			const { code, data } = await getListadoSocios(false, user);
			if (code === 200) {
				setData(data?.slice(0, 5) ?? []);
			} else {
				setData([]);
			}
			setIsLoaded(true);
		} catch (e) {
			setData([]);
			setIsLoaded(true);
		}
	};

	return (
		<section className={className}>
			<header className="o-splitter">
				<h3 className="c-pnp-heading-h4 o-media">
					<span className="o-media__body">
						{ROUTES_LABEL.LIBRO_SOCIOS}
					</span>
				</h3>
				{(isLoaded && data) && data.length > 0 && (
					<CTNButton
						label="Ver todas"
						disabled={!data}
						className={`${className}__btn`}
						mode="secondary"
						size="size-32"
						variant="ghost"
						onClick={() => navigate(ROUTES.LIBRO_SOCIOS)}
					/>
				)}
			</header>
			{(!isLoaded) && (
				<div className={`${className}__loading`}>
					<CTNSpinner size="size-40" />
					<p>Cargando datos</p>
				</div>
			)}
			{(isLoaded && (data?.length ?? 0) > 0 ) && (
				<table className={`[ ${className}__table ${className}__table--fixed ${className}__table--responsive ] [ u-mt-16 ]`}>
					<colgroup className={`${className}__colgroup`}>
						<col style={{ width: '7rem' }} />
						<col /> 
						<col style={{ width: '8rem' }} /> 
						<col />
					</colgroup>
					<tbody className={`${className}__tbody`}>
						{data?.map(({ fecha, titular, participacion, titulo }) => (
							<tr key={titular} className={`${className}__tr`}>
								<td className={`${className}__td`}>
									<b>{fecha}</b>
								</td>
								<td className={`${className}__td`}>
									<CTNEllipsis content={titular} />
								</td>
								<td className={`${className}__td  ${className}__td--end`}>
									{participacion} partic.
								</td>
								<td className={`${className}__td`}>
									<CTNEllipsis content={titulo} />
								</td>
							</tr>
						))}
					</tbody>
				</table>
				
			)}
		</section>
	);
};

export default ListaSociosOverview;
